/**
 * FeatureKeys do sistema — manter sincronizado com asseto-backend feature-keys.enum.ts
 */
export enum FeatureKey {
  MCP_ACCESS = 'MCP_ACCESS',
  INSTAGRAM_INTEGRATION = 'INSTAGRAM_INTEGRATION',
  TIKTOK_INTEGRATION = 'TIKTOK_INTEGRATION',
  WHATSAPP_INTEGRATION = 'WHATSAPP_INTEGRATION',
  FACEBOOK_MESSENGER = 'FACEBOOK_MESSENGER',
  MATTERMOST = 'MATTERMOST',
  GOOGLE_WORKSPACE = 'GOOGLE_WORKSPACE',
  CRM_LEADS = 'CRM_LEADS',
  PIPELINE_CRM = 'PIPELINE_CRM',
  NOTION = 'NOTION',
  CALENDAR = 'CALENDAR',
  PASSWORDS = 'PASSWORDS',
  REIMBURSEMENTS = 'REIMBURSEMENTS',
  CERTIFICATIONS = 'CERTIFICATIONS',
  CONTRACT_MANAGEMENT = 'CONTRACT_MANAGEMENT',
  EMPLOYEE_MANAGEMENT = 'EMPLOYEE_MANAGEMENT',
  EQUIPMENT_MANAGEMENT = 'EQUIPMENT_MANAGEMENT',
  TASK_MANAGEMENT = 'TASK_MANAGEMENT',
  DOCUMENTS = 'DOCUMENTS',
  INVOICES = 'INVOICES',
  CLIENT_MANAGEMENT = 'CLIENT_MANAGEMENT',
  TECH_SYSTEMS = 'TECH_SYSTEMS',
  MEETINGS = 'MEETINGS',
  CLIENT_PLAYBOOKS = 'CLIENT_PLAYBOOKS',
  MIND_MAPS = 'MIND_MAPS',
  STORE_GAMIFICATION = 'STORE_GAMIFICATION',
  VIRTUAL_OFFICE = 'VIRTUAL_OFFICE',
  AI_ANALYSIS = 'AI_ANALYSIS',
  BOARD_ANALYSIS = 'BOARD_ANALYSIS',
  CNPJ_SEARCH = 'CNPJ_SEARCH',
  COMPANY_DOCUMENTS = 'COMPANY_DOCUMENTS',
}

export const FEATURE_KEY_LABELS: Record<FeatureKey, string> = {
  [FeatureKey.MCP_ACCESS]: 'MCP e IA',
  [FeatureKey.INSTAGRAM_INTEGRATION]: 'Integração Instagram',
  [FeatureKey.TIKTOK_INTEGRATION]: 'Integração TikTok',
  [FeatureKey.WHATSAPP_INTEGRATION]: 'Integração WhatsApp',
  [FeatureKey.FACEBOOK_MESSENGER]: 'Facebook Messenger',
  [FeatureKey.MATTERMOST]: 'Mattermost',
  [FeatureKey.GOOGLE_WORKSPACE]: 'Google Workspace',
  [FeatureKey.CRM_LEADS]: 'CRM de Leads',
  [FeatureKey.PIPELINE_CRM]: 'Pipeline de Vendas',
  [FeatureKey.NOTION]: 'Notion / Kanban',
  [FeatureKey.CALENDAR]: 'Calendário',
  [FeatureKey.PASSWORDS]: 'Cofre de Senhas',
  [FeatureKey.REIMBURSEMENTS]: 'Reembolsos',
  [FeatureKey.CERTIFICATIONS]: 'Certificações',
  [FeatureKey.CONTRACT_MANAGEMENT]: 'Gestão de Contratos',
  [FeatureKey.EMPLOYEE_MANAGEMENT]: 'Gestão de Colaboradores',
  [FeatureKey.EQUIPMENT_MANAGEMENT]: 'Gestão de Equipamentos',
  [FeatureKey.TASK_MANAGEMENT]: 'Gestão de Tarefas',
  [FeatureKey.DOCUMENTS]: 'Documentos',
  [FeatureKey.INVOICES]: 'Notas Fiscais',
  [FeatureKey.CLIENT_MANAGEMENT]: 'Gestão de Empresas & Clientes',
  [FeatureKey.TECH_SYSTEMS]: 'Sistemas TEC',
  [FeatureKey.MEETINGS]: 'Reuniões',
  [FeatureKey.CLIENT_PLAYBOOKS]: 'Playbooks',
  [FeatureKey.MIND_MAPS]: 'Mapas Mentais',
  [FeatureKey.STORE_GAMIFICATION]: 'Loja / Gamificação',
  [FeatureKey.VIRTUAL_OFFICE]: 'Escritório Virtual',
  [FeatureKey.AI_ANALYSIS]: 'Análise com IA',
  [FeatureKey.BOARD_ANALYSIS]: 'Análise de Boards',
  [FeatureKey.CNPJ_SEARCH]: 'Buscador de CNPJ',
  [FeatureKey.COMPANY_DOCUMENTS]: 'Documentos da Empresa',
};

export const ALL_FEATURE_KEYS = Object.values(FeatureKey);
